import React from 'react';
import BSForm from 'react-bootstrap/Form';
import styled from 'styled-components';

const BorderlessControl = styled(BSForm.Control)`
    border-top: none;
    border-left: none;
    border-right: none;
`

const Group = styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;

    & > .form-control {
        position: relative;
        flex: 1 1 auto;
        width: 1%;
        min-width: 0;
        margin-bottom: 0;
        margin-left: 6px;
    }
`

interface TextSocialFieldProps {
    name: string
    label: string
    placeholder?: string
    icon: string
    value?: string
    required?: boolean
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TextSocialField: React.FC<TextSocialFieldProps> = ({ name, label, placeholder, icon, value, required, onChange }) => {
    return (
        <BSForm.Group >
            <BSForm.Label>{label}{required ? '*' : ""}</BSForm.Label>
            <Group>
                <img src={icon} alt="icon" />
                <BorderlessControl id={name} name={name} placeholder={placeholder} value={value} onChange={onChange} />
            </Group>
        </BSForm.Group>
    )
}

export default TextSocialField
